import { FC, useEffect, useState } from 'react';
import { useIntl } from 'react-intl';
import { ButtonGroupProps, CarouselInternalState } from 'react-multi-carousel';
import {
  faChevronLeft,
  faChevronRight,
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { createBemBlockBuilder } from '@ebsco-ui/ebsco-ui';

import './Carousel.scss';

export interface CarouselButtonsProps extends Required<ButtonGroupProps> {
  setCarouselState: (carouselState: CarouselInternalState) => void;
}

const cnBem = createBemBlockBuilder(['carousel']);

export const CarouselButtons: FC<CarouselButtonsProps> = ({
  carouselState,
  next,
  previous,
  setCarouselState,
}) => {
  const { $t } = useIntl();
  const [currentSlide, setCurrentSlide] = useState(0);
  const prevSlide = currentSlide === 0 ? 0 : currentSlide - 1;
  const lastVisibleSlideIndex =
    carouselState.totalItems - carouselState.slidesToShow || 0;
  const nextSlide =
    currentSlide === lastVisibleSlideIndex
      ? lastVisibleSlideIndex
      : currentSlide + 1;

  useEffect(() => {
    setCarouselState(carouselState);
  }, [setCarouselState, carouselState]);

  return (
    <div className={cnBem('__buttons')}>
      <button
        type="button"
        className={cnBem('__button')}
        aria-label={$t({
          id: 'carousel.prevButton',
          defaultMessage: 'Go to previous slide',
        })}
        disabled={currentSlide === 0}
        onClick={() => {
          setCurrentSlide(prevSlide);
          previous();
        }}
      >
        <FontAwesomeIcon icon={faChevronLeft} />
      </button>
      <button
        type="button"
        className={cnBem('__button')}
        aria-label={$t({
          id: 'carousel.nextButton',
          defaultMessage: 'Go to next slide',
        })}
        disabled={currentSlide === lastVisibleSlideIndex}
        onClick={() => {
          setCurrentSlide(nextSlide);
          next();
        }}
      >
        <FontAwesomeIcon icon={faChevronRight} />
      </button>
    </div>
  );
};
